/**
 * O que faz: carrega a origem de anúncio dos leads visíveis no faturamento.
 * Onde usa: filtros de campanha e conjunto no painel de vendas.
 * Conexões: React Query e origensAnuncioVendasService.
 * Tabelas: lead_ad_attributions via RPC, somente leitura.
 * Data: 24/09/2026.
 */
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { buscarCatalogoAnunciosVendas, buscarOrigensAnuncioVendas } from '@/services/origensAnuncioVendasService';

export function useOrigensAnuncioVendas(clinicaId: string | null | undefined, leadIds: string[]) {
  const ids = useMemo(() => [...new Set(leadIds)].sort(), [leadIds]);
  return useQuery({
    queryKey: ['origens-anuncio-vendas', clinicaId, ids],
    enabled: Boolean(clinicaId) && ids.length > 0,
    queryFn: ({ signal }) => {
      if (!clinicaId) throw new Error('Selecione uma clínica para filtrar os anúncios.');
      return buscarOrigensAnuncioVendas(clinicaId, ids, signal);
    },
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    retry: 1,
  });
}

export function useCatalogoAnunciosVendas(clinicaId: string | null | undefined) {
  return useQuery({
    queryKey: ['catalogo-anuncios-vendas', clinicaId],
    enabled: Boolean(clinicaId),
    queryFn: ({ signal }) => {
      if (!clinicaId) throw new Error('Selecione uma clínica para listar os anúncios.');
      return buscarCatalogoAnunciosVendas(clinicaId, signal);
    },
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    retry: 1,
  });
}
